import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { Formik } from 'formik';
import React from 'react';
import * as Yup from 'yup';
import { EWCCCustom, StepButtons } from '../CommonComponents';
import styles from '../ewccstyle';
import { Consumer } from './EWCCContext';

const EastWestBankClient = withStyles(styles)(function (props) {
	const { activeStep, handleBack, classes } = props;
	return (
		<Consumer>
			{context => (
				<Formik
					initialValues={{
						deposit: context.deposit,
						ewcc: context.ewcc,
						cardno: context.cardno,
						ewRelConfirm: context.ewRelConfirm,
						ewRelName: context.ewRelName,
						ewRelRelationship: context.ewRelRelationship,
						ewPos: context.ewPos,
						ewPEP: context.ewPEP,
						ewPEPRel: context.ewPEPRel,
						ewPEPRelName: context.ewPEPRelName,
						ewPEPRelRelationship: context.ewPEPRelRelationship,
					}}

					validationSchema={Yup.object().shape({
						deposit: Yup.string().required('Are you an existing EastWest Client is required'),
						cardno: Yup.string().matches(/\d\d\d\d-\?\?\?\?-\?\?\?\?-\d\d\d\d/, "Invalid credit card number").max(19,"Text too long"),
						ewRelConfirm: Yup.string().required('Are you a relative is required'),
						ewRelName: Yup.string().max(150,"Text too long"),
						ewRelRelationship: Yup.string().max(150,"Text too long"),
						ewPEPRelName: Yup.string().max(150,"Text too long"),
						ewPEPRelRelationship: Yup.string().max(150,"Text too long"),
					})}

					onSubmit={(values, actions) => {
						context.updateState("deposit", values.deposit);
						context.updateState("ewcc", values.ewcc);
						context.updateState("cardno", values.cardno);
						context.updateState("ewRelConfirm", values.ewRelConfirm);
						context.updateState("ewRelName", values.ewRelName);
						context.updateState("ewPos", values.ewPos);
						context.updateState("ewPEP", values.ewPEP);
						context.updateState("ewPEPRel", values.ewPEPRel);
						context.updateState("ewPEPRelName", values.ewPEPRelName);
						context.updateState("ewPEPRelRelationship", values.ewPEPRelRelationship);
						actions.setSubmitting(false);
						props.handleSubmit();
					}}
				>
					{props => {
						const {
							values,
							errors,
							touched,
							handleChange,
							handleBlur,
							handleSubmit,
							isSubmitting
						} = props;
						const indentstyle = {
							marginLeft: 10,
						}
						return (
							<form noValidate autoComplete="off">
								<FormControl
									className={classes.formRadio}
									fullWidth
									error={errors.deposit && touched.deposit ? true : false}
								>
									<FormLabel component="legend">Are you an existing EastWest Client? *</FormLabel>
									<RadioGroup
										aria-label=""
										name="deposit"
										className={classes.group}
										value={values.deposit}
										onChange={handleChange}
										onBlur={handleBlur}
									>
										<br />
										<Typography variant="body1">
											Yes
                                        </Typography>
										<FormControlLabel
											style={indentstyle}
											value="Deposit"
											control={<Radio />}
											label="Deposit" />
										<FormControlLabel
											style={indentstyle}
											value="Credit Card"
											control={<Radio />}
											label="Credit Card" />
										<FormControlLabel
											style={indentstyle}
											value="Personal Loan"
											control={<Radio />}
											label="Personal Loan" />	
										<FormControlLabel
											style={indentstyle}
											value="Auto Loan"
											control={<Radio />}
											label="Auto Loan" />
										<FormControlLabel
											style={indentstyle}
											value="Housing Loan"
											control={<Radio />}
											label="Housing Loan" />
										<FormControlLabel
											value="No"
											control={<Radio />}
											label="No" />
									</RadioGroup>

									<FormHelperText
										margin="dense"
										classes={{
											root: classes.radioError,
											error: classes.error,
										}} component="p">
										{errors.deposit && touched.deposit && (<>{errors.deposit}</>)}
									</FormHelperText>

								</FormControl>

								<FormControl
									className={classes.formRadio}
									fullWidth
								>
									<FormLabel component="legend">Are you an existing Principal EastWest Credit Cardholder?</FormLabel>
									<RadioGroup
										aria-label=""
										name="ewcc"
										className={classes.group}
										value={values.ewcc}
										onChange={handleChange}
										onBlur={handleBlur}
									>
										<FormControlLabel value="Yes" control={<Radio />} label="Yes" />
										<FormControlLabel value="No" control={<Radio />} label="No" />
									</RadioGroup>
								</FormControl>
								{values.ewcc === 'Yes'
									?
									<FormControl
										fullWidth
										margin="dense"
										error={errors.cardno && touched.cardno ? true : false}
									>
										<InputLabel required htmlFor="cardno">EastWest Credit Card Number</InputLabel>
										<Input
											id="cardno"
											value={values.cardno}
											onChange={handleChange}
											onBlur={handleBlur}
											error={errors.cardno && touched.cardno ? true : false}
											inputComponent={EWCCCustom}
										/>
										<FormHelperText
											margin="dense"
											classes={{
												root: classes.dropdownError,
												error: classes.error,
											}}
											component="p"
										>
											{errors.cardno && touched.cardno && (<>{errors.cardno}</>)}
										</FormHelperText>

									</FormControl>
									:
									''
								}

								<FormControl
									className={classes.formRadio}
									fullWidth
								>
									<FormLabel component="legend">Are you a Director, Officer, or Shareholder of EastWest Bank? </FormLabel>
									<RadioGroup
										aria-label=""
										name="ewPos"
										className={classes.group}
										value={values.ewPos}
										onChange={handleChange}
										onBlur={handleBlur}
									>
										<FormControlLabel value="Yes" control={<Radio />} label="Yes" />
										<FormControlLabel value="No" control={<Radio />} label="No" />
									</RadioGroup>
								</FormControl>

								<FormControl
									className={classes.formRadio}
									fullWidth
									error={errors.deposit && touched.deposit ? true : false}
								>
									<FormLabel component="legend">Are you a relative of a Director, Officer, or Shareholder of EastWest Bank, EastWest Rural Bank or any subsidiary and/or affiliate of the Filinvest Group of Companies? *</FormLabel>
									<RadioGroup
										aria-label=""
										name="ewRelConfirm"
										className={classes.group}
										value={values.ewRelConfirm}
										onChange={handleChange}
										onBlur={handleBlur}
									>
										<FormControlLabel value="Yes" control={<Radio />} label="Yes" />
										<FormControlLabel value="No" control={<Radio />} label="No" />
									</RadioGroup>
								<FormHelperText
									margin="dense"
									classes={{
										root: classes.radioError,
										error: classes.error,
									}} component="p">
									{errors.ewRelConfirm && touched.ewRelConfirm && (<>{errors.ewRelConfirm}</>)}
								</FormHelperText>
								</FormControl>
								{values.ewRelConfirm === 'Yes'
									?
									<>
										<FormControl
											fullWidth
											margin="dense"
										>
											<TextField
												id="ewRelName"
												label="Name"
												placeholder="First, Middle, Last"
												className={classes.textField}
												value={values.ewRelName}
												onChange={handleChange}
												onBlur={handleBlur}

												helperText={errors.ewRelName && touched.ewRelName ? errors.ewRelName : ''}
                                        		error={errors.ewRelName && touched.ewRelName ? true : false}
											/>
										</FormControl>
										<FormControl
											fullWidth
											margin="dense"
										>
											<TextField
												id="ewRelRelationship"
												label="Relationship"
												className={classes.textField}
												value={values.ewRelRelationship}
												onChange={handleChange}
												onBlur={handleBlur}

												helperText={errors.ewRelRelationship && touched.ewRelRelationship ? errors.ewRelRelationship : ''}
                                        		error={errors.ewRelRelationship && touched.ewRelRelationship ? true : false}
											/>
										</FormControl>
									</>
									:
									''
								}

								<FormControl
									className={classes.formRadio}
									fullWidth
								>
									<FormLabel component="legend">Are you a Politically Exposed Person (PEP)? </FormLabel>
									<RadioGroup
										aria-label=""
										name="ewPEP"
										className={classes.group}
										value={values.ewPEP}
										onChange={handleChange}
										onBlur={handleBlur}
									>
										<FormControlLabel value="Yes" control={<Radio />} label="Yes" />
										<FormControlLabel value="No" control={<Radio />} label="No" />
									</RadioGroup>
								</FormControl>

								<FormControl
									className={classes.formRadio}
									fullWidth
								>
									<FormLabel component="legend">Are you a relative of a Politically Exposed Person (PEP)? </FormLabel>
									<RadioGroup
										aria-label=""
										name="ewPEPRel"
										className={classes.group}
										value={values.ewPEPRel}
										onChange={handleChange}
										onBlur={handleBlur}
									>
										<FormControlLabel value="Yes" control={<Radio />} label="Yes" />
										<FormControlLabel value="No" control={<Radio />} label="No" />
									</RadioGroup>
								</FormControl>
								{values.ewPEPRel === 'Yes'
									?
									<>
										<FormControl
											fullWidth
											margin="dense"
										>

											<TextField
												id="ewPEPRelName"
												label="Name"
												placeholder="First, Middle, Last"
												className={classes.textField}
												value={values.ewPEPRelName}
												onChange={handleChange}
												onBlur={handleBlur}

												helperText={errors.ewPEPRelName && touched.ewPEPRelName ? errors.ewPEPRelName : ''}
                                        		error={errors.ewPEPRelName && touched.ewRelName ? true : false}
											/>
										</FormControl>
										<FormControl
											fullWidth
											margin="dense"
										>

											<TextField
												id="ewPEPRelRelationship"
												label="Relationship"
												className={classes.textField}
												value={values.ewPEPRelRelationship}
												onChange={handleChange}
												onBlur={handleBlur}

												helperText={errors.ewPEPRelRelationship && touched.ewPEPRelRelationship ? errors.ewPEPRelRelationship : ''}
                                        		error={errors.ewPEPRelRelationship && touched.ewPEPRelRelationship ? true : false}
											/>
										</FormControl>
									</>
									:
									''
								}

								<StepButtons isSubmitting={isSubmitting} activestep={activeStep} handleBack={handleBack} handleNext={handleSubmit} />
							</form>
						)
					}
					}
				</Formik>
			)
			}

		</Consumer>
	)
})

export default EastWestBankClient;